import openModal from '../../components/INF-Modal/openModal';
import closeAllMenus from '../../core/INF-closeAllMenus';

export default function () {
  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId !== 'INF-ForgotPassword') {
      return;
    }

    openModal(document.getElementById('recover'));
  });

  document.addEventListener('shopify:section:select', (e) => {
    if (e.detail.sectionId === 'INF-ForgotPassword') {
      openModal(document.getElementById('recover'));
    }
    if (e.detail.sectionId === 'INF-LoginPage') {
      closeAllMenus();
    }
  });

  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.detail.sectionId !== 'INF-ForgotPassword') {
      return;
    }

    closeAllMenus();
  });
}
